import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import isTokenExpired from '../utils/isTokenExpired';
import handleRequest from '../utils/handleRequest';
import { SET_JWT, SET_USER_ROLES } from '../actions/types';
import { GlobalContext } from '../Store';

export default (Component) => {
  return withRouter((props) => {
    const { history } = props;
    const { store, dispatch } = useContext(GlobalContext);

    useEffect(() => {(async () => {
     
      if (store.jwt) {
        //console.log("store in if:" ,store);
        const res = await handleRequest({
          method: 'post',
          url: '/users/silent-login',
        });
     

        if (res.status === 200) {
          dispatch({ type: SET_JWT, payload: { jwt: res.jwt } });
        } else {
          history.push('/login');
        }
      } else if (isTokenExpired(store.jwt)) {
        history.push('/login');
      }
    })()}, [store.jwt, dispatch, history]);

    return <Component {...props} />;
  });
};
